if (!customElements.get('inline-carousel')) {
  class InlineCarousel extends HTMLElement {
    connectedCallback() {
      this.sliderWrapper = this.querySelector('.inline-carousel__items');
      if (!this.sliderWrapper) return;

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`) || this.closest('.section');

      this.enableSlider = this.dataset.enableSlider === 'true';
      this.items = parseInt(this.dataset.items) || 4;
      this.tabletItems = parseInt(this.dataset.tabletItems) || this.items;
      this.navPosition = this.dataset.navPosition || 'header';
      this.slidesPerViewAuto = this.dataset.slidesPerView === 'auto';
      this.loop = this.dataset.loop !== 'false';

      this.hasCardWidth =
        this.slidesPerViewAuto ||
        this.sliderWrapper.classList.contains('card-width-medium') ||
        this.sliderWrapper.classList.contains('card-width-narrow') ||
        this.sliderWrapper.classList.contains('card-width-extra-narrow');

      this.sliderInstance = false;

      if (!this.enableSlider) return;

      this.init();
      document.addEventListener('matchMobile', () => this.init());
      document.addEventListener('unmatchMobile', () => this.init());
    }

    init() {
      if (FoxTheme.config.mqlMobile) {
        this.destroySlider();
      } else {
        this.initSlider();
      }
    }

    initSlider() {
      const columnGap = FoxTheme.utils.getGridColumnGap(this.sliderWrapper);
      const navContainer = this.closest('.section__content-wrapper') || this.section;

      const sliderOptions = {
        slidesPerView: this.hasCardWidth ? 'auto' : (this.tabletItems > 3 ? 3 : this.tabletItems),
        spaceBetween: columnGap.tablet,
        navigation: {
          nextEl: navContainer?.querySelector('.swiper-button-next'),
          prevEl: navContainer?.querySelector('.swiper-button-prev'),
        },
        pagination: false,
        breakpoints: {
          1024: {
            slidesPerView: this.hasCardWidth ? 'auto' : this.items,
            spaceBetween: columnGap.tabletLarge,
          },
          1280: {
            slidesPerView: this.hasCardWidth ? 'auto' : this.items,
            spaceBetween: columnGap.desktop,
          },
        },
        loop: this.loop,
        threshold: 2,
      };

      if (typeof this.sliderInstance !== 'object') {
        this.classList.add('swiper');
        this.sliderWrapper.classList.remove('f-grid');
        this.sliderWrapper.classList.add('swiper-wrapper');
        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();

        const focusableElements = FoxTheme.a11y.getFocusableElements(this);
        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            this.sliderInstance.slider.slideTo(
              this.sliderInstance.slider.slides.indexOf(slide)
            );
          });
        });

        if (this.navPosition === 'slider') {
          this.updateNavVisibility();
          this.sliderInstance.slider.on('slideChange', () => this.updateNavVisibility());
          this.sliderInstance.slider.on('reachBeginning', () => this.updateNavVisibility());
          this.sliderInstance.slider.on('reachEnd', () => this.updateNavVisibility());
        }
      }

      if (Shopify.designMode && typeof this.sliderInstance === 'object') {
        document.addEventListener('shopify:block:select', (e) => {
          if (e.detail.sectionId !== this.sectionId) return;
          const index = Number(e.target.dataset.index);
          this.sliderInstance.slider.slideToLoop(index);
        });
      }
    }

    updateNavVisibility() {
      if (!this.sliderInstance || typeof this.sliderInstance !== 'object') return;

      const container = this.closest('.section__content-wrapper') || this.parentElement;
      const prevBtn = container?.querySelector('.swiper-button-prev--on-slider');
      const nextBtn = container?.querySelector('.swiper-button-next--on-slider');

      if (!prevBtn || !nextBtn) return;

      const slider = this.sliderInstance.slider;
      prevBtn.classList.toggle('swiper-button-visible', !slider.isBeginning || slider.params.loop);
      nextBtn.classList.toggle('swiper-button-visible', !slider.isEnd || slider.params.loop);
    }

    destroySlider() {
      this.classList.remove('swiper');
      if (this.sliderWrapper) {
        this.sliderWrapper.classList.remove('swiper-wrapper');
        this.sliderWrapper.classList.add('f-grid');
      }
      if (typeof this.sliderInstance === 'object') {
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  }

  customElements.define('inline-carousel', InlineCarousel);
}
